import { PositionPill } from '@/components/PositionPill';
import { Grid } from '@/semantic-ui/components';
import { useStores } from '@/store';
import { HasID } from '@lcdev/store';
import { observer } from 'mobx-react';
import * as React from 'react';
import { useEffect } from 'react';
import { Authority, EmployeeActiveStatus } from 'sol-data';

export interface CompletedEmployee {
  employeeId: number;
  completionDate: string;
}

interface PositionGroupProps {
  handlePositionClick: (field: string, value: HasID[]) => void;
  selectedPositions: HasID[];
}

export const PositionGroup = observer(
  ({ handlePositionClick, selectedPositions = [] }: PositionGroupProps) => {
    const { positionStore } = useStores();
    const { filtered } = positionStore;

    useEffect(() => {
      positionStore.fetchAll();
    }, [positionStore]);

    const positionsWithoutInactiveEmployees = filtered.map(({ employees, ...position }: any) => {
      const activeEmployees = employees?.filter(({ status, user, ...employee }: any) => {
        return (
          (status as unknown as EmployeeActiveStatus) === EmployeeActiveStatus.Active &&
          // @ts-ignore
          employee.deleteDatetime === null &&
          !user?.access?.authority.includes(Authority.ReadOnly)
        );
      });

      return {
        ...position,
        employeeCount: activeEmployees?.length ?? 0,
        numberOfEmployees: activeEmployees?.length ?? 0,
        departmentEmployees: activeEmployees,
      };
    });

    const handleClick = (id: number) => {
      const filteredPositions = selectedPositions.some((selected) => selected.id === id)
        ? selectedPositions.filter((selected) => selected.id !== id)
        : [
            ...selectedPositions,
            {
              id,
            },
          ];

      handlePositionClick('positions', filteredPositions);
    };

    return (
      <Grid>
        {positionsWithoutInactiveEmployees.map((position: any) => (
          <PositionPill
            position={position}
            key={`position-${position.id}`}
            selected={selectedPositions.some((selected) => selected.id === position.id)}
            handleClick={handleClick}
          />
        ))}
      </Grid>
    );
  },
);
